import { render, staticRenderFns } from "./VCardStatusLights.vue?vue&type=template&id=020d3372&"
import script from "./VCardStatusLights.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCardStatusLights.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCardStatusLights.vue?vue&type=style&index=0&id=020d3372&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports